export default __webpack_public_path__ + "static/media/play.a05fd6dc.png";